// Deter accidental saving through the media context menu and image drag.
// Files delivered to a browser remain retrievable from its network requests.
const mediaTarget = 'img, video, .avatar, .demo-avatar-stack, .gallery-main, .comparison, .ugc-card, .proof-grid article, .story-media, .wide-image, .feature-grid article';
document.addEventListener('contextmenu', event => {
  if (event.target.closest?.(mediaTarget)) event.preventDefault();
});
document.addEventListener('dragstart', event => {
  if (event.target.closest?.(mediaTarget)) event.preventDefault();
});
